import "../styles/genAIJobRoles.css";
import {
  FaRobot,
  FaPenNib,
  FaCogs,
  FaPlug,
  FaDatabase,
  FaChartLine,
  FaComments
} from "react-icons/fa";

export default function GenAIJobRoles() {
  const roles = [
    { title: "Generative AI Developer", icon: <FaRobot /> },
    { title: "Prompt Engineer", icon: <FaPenNib /> },
    { title: "AI Application Developer", icon: <FaCogs /> },
    { title: "LLM Integration Engineer", icon: <FaPlug /> },
    { title: "RAG / Vector Database Engineer", icon: <FaDatabase /> },
    { title: "AI Product Analyst", icon: <FaChartLine /> },
    { title: "AI Chatbot Developer", icon: <FaComments /> }
  ];

  return (
    <section className="genai-roles-page">
      <div className="roles-container">

        {/* HEADER */}
        <div className="roles-header">
          <h2>
            Program Key <span>Job Roles</span>
          </h2>
          <p>
            Career opportunities unlocked after completing the
            <strong> Gen AI Starter Program</strong>
          </p>
        </div>

        {/* ROLES GRID */}
        <div className="roles-grid">
          {roles.map((role, index) => (
            <div className="role-card" key={index}>
              <div className="role-icon">{role.icon}</div>
              <h4>{role.title}</h4>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
